import { getPaymentInfo } from '@/shared/api/payment';

import { Method } from '../types';
import { type Responder } from './respond-with-message';
import { validateMessageData } from './validate-message-data';
import { warnIncorrectValues } from './warn-incorrect-values';

export const getPaymentInfoHandler = async (value: any, respond: Responder) => {
  const { externalId } = value;

  if (!validateMessageData({ value: externalId, allowedTypes: ['number', 'string'] })) {
    warnIncorrectValues(Method.GET_PAYMENT_INFO, 'externalId', ['number', 'string']);
  }

  const data = await getPaymentInfo(externalId);
  respond({ method: Method.GET_PAYMENT_INFO, value: data });
};
